<i18n locale="en" lang="json">
{
  "title": "Page expired",
  "message": "This page has expired."
}
</i18n>
<i18n locale="nl" lang="json">
{
  "title": "Pagina vervallen",
  "message": "Deze pagina is komen te vervallen."
}
</i18n>

<template>
  <div>
    <the-page-title :title="t('title')" test-id="deprecated" />
    <the-title-bar
      :title="t('title')"
      :back-button-location="{ name: RouteName.LoginIndex }"
    />
    <base-page>
      <base-alert type="warning">{{ t('message') }}</base-alert>
    </base-page>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
